import React from "react";
import classNames from "classnames";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import ModalManager from "@/components/ModalComponent/ModalManager";
import i18n from "@/i18n";
import DataBusDefaults from "@/services/DataBusDefaults";
import APOfferForm from "./APOfferForm";
import { useActivityConstants } from "../../../../ActivityHooks";
import { APActivity } from "../../../../ActivityInterfaces";
import { APOfferAccordionList } from "./offer-list/APOfferAccordionList";
import { APRouteWrapper } from "./offer-list/APRouteWrapper";
import "./APOfferList.scss";
import ActivityUtils from "@/modules/activity-components/ActivityUtils";

interface APOfferListProps {
  activity: APActivity;
}

const APOfferList = (props: APOfferListProps) => {
  const constants = useActivityConstants();

  return (
    <APRouteWrapper defaultStatus="accepted">
      {({ baseUrl, activeStatus }) => (
        <div className={classNames("ap-offer-list")}>
          <div className="list-header">
            <div className="fill" />
            <BFButton
              onClick={() => {
                ModalManager.show({
                  noPadding: true,
                  size: "sm",
                  content: (state, setState, close) => (
                    <APOfferForm
                      constants={constants}
                      activityId={props.activity._id}
                      onClose={close}
                      onSuccess={() => {
                        DataBusDefaults.reload({
                          identifiers:
                            ActivityUtils.getActivityOfferStatusKeys().map(
                              (id) => `offer-list-${id}`
                            ),
                        });
                      }}
                    />
                  ),
                });
              }}
            >
              {i18n.t("apTemplate:OfferList.CreateNew", "Anlegen")}
            </BFButton>
          </div>
          <div className="list-accordion-wrapper __card">
            <APOfferAccordionList
              activity={props.activity}
              identifierPrefix="offer-list"
              statuses={ActivityUtils.getActivityOfferStatusKeys()}
              baseUrl={baseUrl}
              activeStatus={activeStatus}
            />
          </div>
        </div>
      )}
    </APRouteWrapper>
  );
};

export default APOfferList;
